import React from "react";
import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { DENVER_NEIGHBORHOODS } from "@/lib/denver";

export const DenverServiceArea = () => {
  return (
    <section
      id="service-area"
      className="relative py-24 sm:py-32 bg-[#142238] border-y border-slate-900"
      data-testid="denver-service-area"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-12">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-[#1E88E5]" />
            <span className="font-heading text-xs font-bold tracking-[0.3em] uppercase text-[#E6B445]">
              Denver service area
            </span>
          </div>
          <h2 className="font-heading text-4xl sm:text-6xl font-black uppercase tracking-tight text-white">
            From LoDo to <br />
            <span className="text-[#1E88E5]">Highlands Ranch.</span>
          </h2>
          <p className="text-slate-400 leading-relaxed mt-6 text-lg">
            One crew, one standard, the whole Denver metro. We run multi-site days
            to keep routing tight — so your quote stays lean and your schedule locks
            in fast.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3"
        >
          {DENVER_NEIGHBORHOODS.map((n, i) => (
            <div
              key={n}
              data-testid={`neighborhood-${i}`}
              className="flex items-center gap-2 px-4 py-3 bg-[#0B1726] border border-slate-800 rounded-sm hover:border-[#1E88E5]/60 transition-colors"
            >
              <MapPin className="w-3.5 h-3.5 text-[#1E88E5] flex-shrink-0" strokeWidth={2} />
              <span className="text-slate-300 text-sm">{n}</span>
            </div>
          ))}
        </motion.div>

        <p className="text-slate-500 text-sm mt-8">
          Don't see your neighborhood? Call or text 719-644-6105 — if it's in Denver metro
          or along the I-25 corridor, we cover it.
        </p>
      </div>
    </section>
  );
};
